module.exports = __webpack_public_path__ + "static/media/stop.94032e51.svg";